import RadioButton    from 'scripts/defa/basic/view-radio-button-view';
import CollectionView from 'scripts/poppet/collection-view';

/**
 * defa.views.AlarmCentralCollectionView
 * A view to list several AlarmCentrals with.
 * @version 1.2.0
 */


const AlarmCentralCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: RadioButton,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default AlarmCentralCollectionView;